import React,{useEffect,useState} from "react";
import "./HeroBanner.css";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const HeroBanner = ({
  Heading="",
  subHeading="",
  spanHeading="",
  nextLineSpanHeading,
  Paragraph="",
  btnText,
  bgImg,
  bgVideo=false,
  btn=false,
  btnRef="/",
  socialLinks=false,
  serviceForm=false,
  bgEffect=false,
  heightAuto=false,
  smallHeading=false,
  sideLinks=true
}) => {
  const navigate = useNavigate()
  const paragraphs = Paragraph.split('\n').map((paragraph, index) => <p key={index} className='hero-paragraph mx-auto' style={{width:"80%"}}>{paragraph}</p>);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1150);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1150);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 



  const formSubmitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post("/send-contact-form-main", {
        email: email,
        name:name,
        message:message,
        phoneNum:phone,
        service:service,
        formType: "Contact page Form",
      })
      .then((response) => {
        if (response.data.msg === "success") {
          setError(false);
          setSuccess("Message sent Successfully!");
          setLoading(false);
          // setEmail("");
          window.open("/thank-you", '_blank');
        } else if (response.data.msg === "fail") {
          setSuccess(false);
          setError("Failed to send message, try again by reloading the page.");
          setLoading(false);
          setEmail("");
        }
      });
  };
  
  const handlePhoneChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, ''); 
    const maxLength = 25;


    if (numericValue.length <= maxLength) {
      setPhone(numericValue);
    }
  };

  const servicesData = [
    {
        name:"Executive Membership",
    },
    {
        name:"Sport medicine",
    },
    {
        name:"Audiology",
    },
    {
        name:"Dna analysis",
    },
    {
        name:"Global Medical Consulting",
    },
    // {
    //     name:"Gyno uro",
    // },
    {
        name:"Medical aesthetics",
    },
    {
        name:"Aging & wellness",
    },
    {
        name:"IV therapy",
    },
    {
        name:"Naturopathic medicine",
    },
    {
        name:"Orthopaedic",
    },
    {
        name:"Pelvic floor Men",
    },
    {
        name:"Pelvic floor Women",
    },
]
  return (
    <div
      className={`common_hero_section ${bgVideo && "bg-video"} ${
        heightAuto && "h-cus-auto"
      } `}
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className={`${bgEffect && "bg-effect"} h-100`}>
        {bgVideo && (
          <video autoPlay loop muted>
            <source src="./images/backgroundVideo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}

        <div className="hero-container h-100  px-0">
          <div className="wrapper d-flex flex-column pt-0">
            <Header />
            <div className=" d-flex align-items-center py-5 my-auto container">
              {sideLinks && (
                <div className="d-flex flex-column justify-content-center align-items-center gap-3">
                  <h3 className="verticle-text" style={{ color: "white" }}>
                    SCROLL
                  </h3>
                  <div
                    className=""
                    style={{
                      border: "1.5px solid white",
                      width: "0",
                      height: "100px",
                    }}
                  ></div>
                </div>
              )}

              <div className="row gy-2 w-100 align-items-center">
                <div
                  className={
                    serviceForm
                      ? "col-md-6 "
                      : "col-12 hero_content_wrapper px-3 w-100"
                  }
                >
                  <div className="hero-text-content w-100 text-lg-start text-center">
                    <h5 className="hero-sub-heading">{subHeading}</h5>
                    <h1
                      className={`main-heading main-title my-3 ${
                        smallHeading && "hero-section-heading-small"
                      }`}
                    >
                      {Heading}
                      <span className="" style={{ textTransform: "none" }}>
                        {spanHeading}
                      </span>
                      {nextLineSpanHeading && (
                        <>
                          <br />{" "}
                          <span className="" style={{ textTransform: "none" }}>
                            {nextLineSpanHeading}
                          </span>
                        </>
                      )}
                    </h1>
                    <p className="hero-paragraph mx-auto">{paragraphs}</p>
                    {btn && (
                      <button
                        className="genral-btn mt-4"
                        onClick={() => {
                          navigate(btnRef);
                        }}
                      >
                        {btnText}
                      </button>
                    )}
                    {socialLinks && (
                      <div className="social-links py-2">
                        <div className="link-container d-flex align-items-center gap-2 pb-3">
                          <img
                            src="/images/icons/phone-contact.svg"
                            alt="icon"
                            style={{ filter: "invert(1)" }}
                          />
                          <a
                            href="tel:416-849-5555"
                            style={{ textDecoration: "none", color: "black" }}
                            className="m-0"
                          >
                            Phone: 416-849-5555
                          </a>
                        </div>
                        <div className="link-container d-flex align-items-center gap-2 pb-3">
                          <img
                            src="/images/icons/phone-contact.svg"
                            alt="icon"
                            style={{ filter: "invert(1)" }}
                          />
                          <p className="m-0">Fax: 416-849-5551</p>
                        </div>
                        <div className="link-container d-flex align-items-center gap-2">
                          <img
                            src="/images/icons/loc-contact.svg"
                            alt="icon"
                            style={{ filter: "invert(1)" }}
                          />
                          <p className="m-0">
                            55 Avenue Road, Suite 2000, East Tower Toronto, ON,
                            Canada, M5R 3L2
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {serviceForm && (
                  <div className="col-md-6">
                    <form onSubmit={formSubmitHandler} className="service-form d-flex flex-column px-5 py-5">
                      <h3 className="body-heading" style={{ color: "black" }}>
                        Let’s get in touch!
                      </h3>

                      <input 
                        type="text" 
                        placeholder="Your Full Name" 
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <input 
                        type="email" 
                        placeholder="Your Email Address" 
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <input 
                        type="tel" 
                        placeholder="Phone Number" 
                        value={phone}
                        maxLength="25"
                        required
                        onChange={handlePhoneChange}
                      />
                      <select
                        onChange={(e) => setService(e.target.value)}
                        required
                        defaultValue="" 
                      >
                        <option value="" disabled>
                          Select Service
                        </option>

                        {servicesData.map((ele) => (
                          <option key={ele.name} value={ele.name}>
                            {ele.name}
                          </option>
                        ))}
                      </select>

                      <textarea
                        placeholder="Your Message"
                        required
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        rows={5}
                      ></textarea>
                      <button className="service-from-btn genral-btn" type="submit">
                        Submit
                        {loading ? (
                          <Spinner
                              animation="border"
                              role="status"
                              style={{ color: "white" ,width:"15px",height:"15px",marginLeft:"10px"}}
                          />
                      ) : (
                      success ? (
                          <div>
                          {setLoading(false)}
                          {/* {alert(success)} */}
                          {navigate("/thank-you")}

                          {setSuccess(false)}
                          </div>
                      ) : (
                          error && (
                          <div>
                              {setLoading(false)}
                              {alert(error)}
                              {setError(false)}
                          </div>
                          )
                      )
                      )}
                      </button>
                    </form>
                  </div>
                )}
              </div>
              {sideLinks && (
                <div className="d-flex flex-column justify-content-center align-items-center gap-3">
                  <div className="icon-container d-flex flex-column align-items-center gap-3">
                    <a
                      href="https://www.facebook.com/meadowsequine/"
                      target="blank"
                    >
                      <img src="/images/icons/hero-fb-icon.svg" alt="icon" />
                    </a>

                    <a
                      href="https://www.instagram.com/meadows.equine/"
                      target="blank"
                    >
                      <img src="/images/icons/hero-insta-icon.svg" alt="icon" />
                    </a>
                  </div>
                  <div
                    className=""
                    style={{
                      border: "1.5px solid white",
                      width: "0",
                      height: "120px",
                    }}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner; 